export const LOGOUT_KEY = 'logout';
export const INVALID_USER_KEY = 'InvalidUserPrefix';
export const AUTO_LOGOUT_KEY = 'auto-logout';
export const NO_RESULT_ERROR = 'NoResultError';
export const IDP_HAG_PUOLESTA = 'HagPuolesta';
